import React, { useState } from 'react';
import PropTypes from 'prop-types';
import YoutubePlayer from '../../atoms/YoutubePlayer';


import "./VideoPlayer.scss"


const VideoPlayer = ({ url,title }) => {
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [playerKey, setPlayerKey] = useState(0);

    const handleError = (message) => {
        setError(true);
        setErrorMessage(message);
        setPlayerKey(prevKey => prevKey + 1);
    };

    const handleRetry = () => {
        setError(false);
        setErrorMessage("");
        setPlayerKey(prevKey => prevKey + 1);
    };

    return (
        <div style={{ width: "100%", height: "100%" }}>
            {error && (
                <div className="video-error">
                    <div>Error : {errorMessage}</div>
                    <button type="button" className="video-error-button" onClick={handleRetry}>Retry</button>
                </div>
            )}
            {!error && <YoutubePlayer key={playerKey} src={url} onError={handleError} title={title} />}
        </div>
    );
}


export default VideoPlayer;

VideoPlayer.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
}